import { render, staticRenderFns } from "./patientItem.vue?vue&type=template&id=9e9a2226&scoped=true&"
import script from "./patientItem.vue?vue&type=script&lang=js&"
export * from "./patientItem.vue?vue&type=script&lang=js&"
import style0 from "./patientItem.vue?vue&type=style&index=0&id=9e9a2226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9a2226",
  null
  
)

export default component.exports